import { combineReducers } from "redux";

import { rolesEntriesReducer } from "./Entities/reducer";

export const rolesReducer = combineReducers({ entries: rolesEntriesReducer });